module.exports = __webpack_public_path__ + "static/img/qrcode.2bed36d0.png";